module.exports = __webpack_public_path__ + "static/media/20170501-DSC08640-18_Small.93b2de30.jpg";